import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('agencies', ['agency']),

    stateName: {
      get () {
        return this.agency.name
      },

      set (value) {
        this.setAgencyProperty({ property: 'name', value })
      }
    },

    stateAbbreviation: {
      get () {
        return this.agency.abbreviation
      },

      set (value) {
        this.setAgencyProperty({ property: 'abbreviation', value })
      }
    },

    stateEnabled: {
      get () {
        return this.agency.enabled
      },

      set (value) {
        this.setAgencyProperty({ property: 'enabled', value })
      }
    }
  },

  methods: {
    ...mapActions('agencies', ['setAgencyProperty'])
  }
}
